// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"b84c73cb","89":"44abd510","147":"dcdb71a2","215":"bbb045b2","241":"d7cd2992","453":"ad1a7526","656":"d005808f","698":"21af5c47","816":"b51a7c97","931":"29fc46a8"}[chunkId] + ".chunk.js";
};